module.exports = __webpack_public_path__ + "static/media/play_button.df5af3e8.svg";